// Apolo IDE — PlanEmptyCanvas (sprint plan-tab-v1, E2).
//
// Estado vazio: ou usuário não tem planos ainda, ou tem mas nenhum
// selecionado. Em ambos casos: card glass + 1 CTA primário.

import { motion } from 'framer-motion';
import { Loader2, Plus, Sparkles } from 'lucide-react';

export default function PlanEmptyCanvas({ hasPlans, onCreate, loading }) {
  return (
    <div className="flex flex-1 items-center justify-center bg-apolo-bg p-6">
      <motion.div
        initial={{ opacity: 0, y: 12, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        className="relative flex max-w-md flex-col items-center gap-4 rounded-2xl border border-apolo-plan-accentBorder bg-apolo-surface1/60 p-8 text-center backdrop-blur-md"
        style={{ boxShadow: 'var(--apolo-plan-glow-wide)' }}
      >
        <span
          aria-hidden="true"
          className="inline-flex h-14 w-14 items-center justify-center rounded-full"
          style={{
            background: 'var(--apolo-plan-gradient)',
            boxShadow: 'var(--apolo-plan-glow-tight)',
          }}
        >
          <Sparkles size={26} className="text-white" />
        </span>
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">
            {hasPlans ? 'Escolha um plano' : 'Comece um plano'}
          </h1>
          <p className="mt-2 text-sm text-apolo-textSecondary">
            {hasPlans
              ? 'Selecione um plano na lateral pra abrir o canvas.'
              : 'Transforme uma ideia em sprint: arraste cards, escreva, insira skills.\nO Apolo entrega tudo pronto pra Code.'}
          </p>
        </div>

        {!hasPlans ? (
          <button
            type="button"
            onClick={onCreate}
            disabled={loading}
            className="inline-flex items-center gap-2 rounded-full px-5 py-2 text-sm font-semibold text-white transition hover:brightness-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-plan-accentRing disabled:opacity-60"
            style={{ background: 'var(--apolo-plan-gradient)', boxShadow: 'var(--apolo-plan-glow-tight)' }}
          >
            {loading ? <Loader2 size={14} className="animate-spin" aria-hidden="true" /> : <Plus size={14} />}
            Criar primeiro plano
          </button>
        ) : (
          <span className="rounded-full border border-apolo-plan-accentBorder bg-apolo-plan-accentMuted px-3 py-1 text-xs font-medium text-apolo-plan-accent">
            ← clique em um plano
          </span>
        )}

        <span className="text-[10px] text-apolo-textTertiary">canvas mode · v1</span>
      </motion.div>
    </div>
  );
}
